import type { QueryClient } from '@tanstack/vue-query';
import { supportMeasureEntryKeys } from './supportMeasureEntry.keys';

export const invalidateSupportMeasureEntryQueries = async (
  queryClient: QueryClient,
  params: { entryId: number },
): Promise<void> => {
  await queryClient.invalidateQueries({
    queryKey: supportMeasureEntryKeys.filterStudents(params.entryId),
    exact: false,
  });
};
